// Sale model line
import mainStore from "store/mainStore";

import ProductCombine from "./ProductCombine";
import ProductCombo from "./ProductCombo";
import ProductDiscount from "./ProductDiscount";
import ModalTags from "./components/ModalTags";
import { FormattedMessage as FM } from "react-intl";
import { PlusCircleIcon } from "components/Icons";

const getProduct = (value, config) => {
  const { record } = mainStore.getState();

  if (!value || value === "") return;
  let category_ids = [];
  const { product_categories, "product_categories.": p_categories } =
    record?.shop ?? {};
  let categories = product_categories?.values() ?? p_categories;
  if (!categories) return;
  for (const item of categories) {
    category_ids.push(...[item.id, ...item.childs]);
  }

  let domain = [
    ["template.active", "=", true],
    ["active", "=", true],
    ["template.salable", "=", true],
  ];
  if (config.filter_product_by_analytic) {
    domain.push(["analytic_accounts.shop", "=", record.shop.id]);
  }
  if (category_ids) {
    domain.push(["template.categories", "in", category_ids]);
  }

  const target_words = value.split(" ");
  target_words.forEach((tw) => {
    if (tw.length <= 1) {
      return;
    }
    const clause = [
      "OR",
      ["template.name", "ilike", `%${tw}%`],
      ["description", "ilike", `%${tw}%`],
      ["code", "ilike", `%${tw}%`],
      // ["barcode", "=", `%${tw}%`],
    ];
    domain.push(clause);
  });
  return domain;
};

const fix = (val, decimals = 4) => Number(Number(val).toFixed(decimals));

const onChangeProduct = async (activeChild, storeChild) => {
  const product = activeChild?.product;
  if (!product) return;
  let unit = product["sale_uom."];
  const { sale_price_taxed, list_price } = product;

  storeChild.unit_price = fix(list_price);
  storeChild.base_price = fix(list_price);
  storeChild.unit = unit.id;
  storeChild.description = product.name;

  activeChild.unit_price = fix(list_price);
  activeChild.base_price = fix(list_price);
  activeChild.unit = unit;
  activeChild.unit_price_w_tax = fix(sale_price_taxed);
  activeChild.amount_w_tax = fix(sale_price_taxed);
};

const onChangeQty = (record) => {
  if (record.quantity && record.amount_w_tax) {
    const qty = record.quantity;
    if (record.discount) {
      const { unit_price_w_tax, discount } = record;
      const amount_ =
        unit_price_w_tax * qty - (unit_price_w_tax * qty * discount) / 100;
      record.amount_w_tax = fix(amount_);
    } else {
      record.amount_w_tax = fix(record.unit_price_w_tax * qty);
    }
  }
};

const searchUnit = (value, record) => {
  const dom = [["category", "=", record?.unit?.category]];
  if (value) {
    dom.push(["name", "ilike", `%${value}%`]);
  }
  return dom;
};

// const getTotalAmount = (activeRecord) => {
//   let amount_w_tax = 0;
//   if (activeRecord.unit_price_w_tax && activeRecord.quantity) {
//     amount_w_tax = activeRecord.unit_price_w_tax * activeRecord.quantity;
//   }
//   return amount_w_tax;
// };

const onChangeDeliveryFee = async (record, store) => {
  const { delivery_fee, quantity } = record;
  if (delivery_fee && quantity) {
    const fee = Number(delivery_fee.replace(/[^0-9.-]+/g, ""));
    record.amount_w_tax = fix(fee * quantity);
    record.unit_price_w_tax = fix(fee);
    store.unit_price = fix(fee);
    store.base_price = fix(fee);
  }
};

const getDisabled = (record) => record?.status_order !== "draft";

function accDelete(rec) {
  console.log("accDelete", rec);
  return rec.status_order === "draft";
}

function accEdit(rec) {
  return rec.status_order === "draft";
}

const getView = (config) => {
  Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
  };
  const attrsProduct = [
    "id",
    "list_price",
    "name",
    "sale_price_taxed",
    "sale_uom.rec_name",
    "template.categories",
    "products_mix.option",
    "template.name",
  ];
  if (config?.productTagActive) {
    attrsProduct.push("tags.name");
  }

  const DictCtxView = {
    selectable: "one",
    model: "sale.line",
    row_selectable: false,
    table_action: ["add", "edit", "delete"],
    form_action: ["add", "edit", "delete"],
    access: {
      delete: accDelete,
      edit: accEdit,
    },
    target: "sale",
    webfields: {
      product: {
        type: "many2one",
        model: "product.product",
        recSearch: (value) => getProduct(value, config),
        withChange: onChangeProduct,
        attrs: attrsProduct,
        readOnly: getDisabled,
        required: true,
      },
      unit: {
        type: "many2one",
        model: "product.uom",
        recSearch: searchUnit,
        // withChange: onChangeUnit,
        readOnly: true,
        attrs: ["id", "name", "category", "factor"],
      },
      quantity: {
        type: "integer",
        withChange: onChangeQty,
        required: true,
        readOnly: getDisabled,
        default: 1,
      },
      note: { type: "text" },
      status_order: {
        type: "char",
        readOnly: true,
        default: "draft",
        translate: true,
      },
      unit_price: { type: "numeric", readOnly: true, decimalPlaces: 2 },
      delivery_fee: {
        type: "numeric",
        visible: (field, rec) => {
          return rec.set_delivery_fee;
        },
        dependents: ["set_delivery_fee"],
        withChange: onChangeDeliveryFee,
        readOnly: getDisabled,
        search: false,
      },
      set_delivery_fee: {
        type: "boolean",
        search: false,
        readOnly: getDisabled,
      },
      unit_price_w_tax: { type: "numeric", readOnly: true, decimalPlaces: 2 },
      amount_w_tax: { type: "numeric", readOnly: true, decimalPlaces: 2 },
    },
    webtree: [
      { name: "product", width: "40%" },
      { name: "quantity", width: "10%" },
      { name: "unit_price_w_tax", width: "23%" },
      { name: "amount_w_tax", width: "23%" },
      { name: "status_order", width: "10%" },
    ],
    webform: [
      { name: "product" },
      { name: "quantity" },
      { name: "unit_price_w_tax" },
      { name: "amount_w_tax" },
      { name: "note" },
      {
        id: "fee",
        grid: [
          { name: "set_delivery_fee", dependents: ["delivery_fee"] },
          { name: "delivery_fee" },
        ],
        cols: "grid-cols-2",
        colSpan: "col-span-1",
      },
      { name: "status_order" },
      {
        id: "buttons",
        grid: [
          {
            type: "button_custom_modal",
            readOnly: getDisabled,
            Component: ProductCombo,
            color: "lime",
            icon: "fi fi-bs-hamburger-soda",
            name: "button_combo",
            button_ok: false,
          },
          {
            type: "button_custom_modal",
            Component: ProductCombine,
            readOnly: getDisabled,
            color: "indigo",
            icon: "fi fi-rr-pizza-slice",
            name: "button_combine",
            button_ok: false,
          },
          {
            type: "button_custom_modal",
            Component: ProductDiscount,
            readOnly: getDisabled,
            color: "rose",
            icon: "fi fi-rr-badge-percent",
            name: "button_discount",
            button_ok: false,
          },
          {
            type: "button_custom_modal",
            readOnly: getDisabled,
            Component: ModalTags,
            color: "blue",
            icon: (
              <span className="flex items-center gap-1">
                <PlusCircleIcon className="h-5 w-5 fill-current" />
                <FM id="sale.lines.add_tags" />
              </span>
            ),
            name: "button_tag",
            button_ok: false,
            visible: (name, record) => {
              return config?.productTagActive && !!record?.product?.id;
            },
          },
        ],
        cols: "grid-cols-4",
        colSpan: "col-span-2",
      },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
